import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createChallengePlayerLink, useChallengePlayer } from '@infl-ts/util-use-challenge-player';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { RouterLink } from '../router-link';
import { jsx as _jsx } from "react/jsx-runtime";

var NewActivityButton = function NewActivityButton(_ref) {
  var challengeId = _ref.challengeId,
      closeDrawer = _ref.closeDrawer;

  var _useChallengePlayer = useChallengePlayer(),
      challengeConfig = _useChallengePlayer.challengePlayerState.challengeConfig;

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Button, {
    sx: {
      mx: 2,
      mt: 3,
      mb: 2,
      width: 'fit-content'
    },
    variant: "contained",
    component: RouterLink,
    to: createChallengePlayerLink(pathname, _objectSpread(_objectSpread({}, challengeConfig !== null && challengeConfig !== void 0 ? challengeConfig : {
      uuid: challengeId
    }), {}, {
      activity: 'new'
    })),
    onClick: closeDrawer,
    "data-element": "Button",
    "data-component": "NewActivityButton",
    "data-source-file": "activity-action.tsx",
    children: t('Start new')
  });
};

export var hasCompletionsLeft = function hasCompletionsLeft(challenge) {
  return challenge.remainingCompletionCount === null || challenge.remainingCompletionCount > 0;
};
export var hasMemberCompletionsLeft = function hasMemberCompletionsLeft(challenge) {
  return challenge.memberRemainingCompletionCount === null || challenge.memberRemainingCompletionCount > 0;
};

var ActivityAction = function ActivityAction(_ref2) {
  var challenge = _ref2.challenge,
      closeDrawer = _ref2.closeDrawer;
  var challengeHasCompletionsLeft = hasCompletionsLeft(challenge);
  var memberHasChallengeCompletionsLeft = hasMemberCompletionsLeft(challenge);
  return challengeHasCompletionsLeft && (challenge.multiComplete && memberHasChallengeCompletionsLeft || !challenge.multiComplete && !challenge.inProgress) ? /*#__PURE__*/_jsx(NewActivityButton, {
    challengeId: challenge.id,
    closeDrawer: closeDrawer
  }) : null;
};

export default ActivityAction;